import api from './api'
import { API_ENDPOINTS } from '../config/api'
import { getDeviceId } from './deviceId'

export const authService = {
  login: async (credentials) => {
    const response = await api.post(API_ENDPOINTS.AUTH.LOGIN, { ...credentials, deviceId: getDeviceId() })
    return response.data
  },

  logout: async () => {
    const response = await api.post(API_ENDPOINTS.AUTH.LOGOUT)
    return response.data
  },

  refreshToken: async () => {
    const response = await api.post(API_ENDPOINTS.AUTH.REFRESH)
    return response.data
  },

  getProfile: async () => {
    const response = await api.get(API_ENDPOINTS.USER.PROFILE)
    return response.data
  },

  ownerLogin: async (credentials) => {
    const response = await api.post(API_ENDPOINTS.AUTH.OWNER_LOGIN, { ...credentials, deviceId: getDeviceId() })
    return response.data
  },

  // Executive (multi-login) accounts — the response already carries the safe
  // executive object + permissions, so no profile call follows this
  executiveLogin: async (credentials) => {
    const username = credentials.username || credentials.email
    const response = await api.post(API_ENDPOINTS.MULTI_LOGIN.LOGIN, {
      username,
      password: credentials.password
    })
    return response.data
  },

  getOwnerProfile: async () => {
    const response = await api.get(API_ENDPOINTS.USER.OWNER_PROFILE)
    return response.data
  },

  // Owner ka session profile — staff wale endpoint jaisa hi shape deta hai
  // ({ success, data: { user } }), isliye login/2FA/init me role ke hisaab se
  // sirf endpoint badalta hai, unwrapping ek hi rehti hai.
  getOwnerProfileV2: async () => {
    const response = await api.get(API_ENDPOINTS.USER.OWNER_PROFILE_V2)
    return response.data
  },
  updatePlatformConfigurations: async (data) => {
    const response = await api.post(API_ENDPOINTS.AUTH.UPDATE_PLATFORM_CONFIG, data)
    return response.data
  },

  // 2FA Methods
  verifyStaff2FA: async (data) => {
    const response = await api.post(API_ENDPOINTS.AUTH.VERIFY_2FA_STAFF, { ...data, deviceId: getDeviceId() })
    return response.data
  },

  verifyOwner2FA: async (data) => {
    const response = await api.post(API_ENDPOINTS.AUTH.VERIFY_2FA_OWNER, { ...data, deviceId: getDeviceId() })
    return response.data
  },

  generate2FALink: async () => {
    const response = await api.post(API_ENDPOINTS.AUTH.GENERATE_2FA_LINK)
    return response.data
  },

  verifyPassword: async (password) => {
    const response = await api.post(API_ENDPOINTS.AUTH.VERIFY_PASSWORD, { password })
    return response.data
  },

  sendDisable2FACode: async () => {
    const response = await api.post(API_ENDPOINTS.AUTH.SEND_DISABLE_2FA_CODE)
    return response.data
  },

  disable2FA: async (data) => {
    const response = await api.post(API_ENDPOINTS.AUTH.DISABLE_2FA, data)
    return response.data
  },

  // 'Secure Auth Verification App' (Android) — the phone holds a TOTP secret,
  // so the site only issues the pairing code and checks the code read back out
  // of the app. The claim call in between is made by the APP, never from here.
  // No password: the code shows as soon as the tab opens, and pairing in the
  // app (user id + password + this code) is what switches secure auth on.
  androidPair: async () => {
    const response = await api.post(API_ENDPOINTS.AUTH.ANDROID_PAIR, {})
    return response.data
  },

  androidDisable: async (otp) => {
    const response = await api.post(API_ENDPOINTS.AUTH.ANDROID_DISABLE, { otp })
    return response.data
  },

  // Google Authenticator: password → { qrCode, secret }, then the first code
  // from the app switches it on.
  googleSetup: async (password) => {
    const response = await api.post(API_ENDPOINTS.AUTH.GOOGLE_SETUP, { password })
    return response.data
  },

  googleEnable: async (otp) => {
    const response = await api.post(API_ENDPOINTS.AUTH.GOOGLE_ENABLE, { otp })
    return response.data
  },

  googleDisable: async (otp) => {
    const response = await api.post(API_ENDPOINTS.AUTH.GOOGLE_DISABLE, { otp })
    return response.data
  },

  changePassword: async (data, role) => {
    const endpoint = role === 'owner'
      ? API_ENDPOINTS.AUTH.OWNER_UPDATE_PASSWORD
      : API_ENDPOINTS.AUTH.STAFF_UPDATE_PASSWORD
    const response = await api.post(endpoint, data)
    return response.data
  },

  acceptRules: async (role, id) => {
    const endpoint = role === 'owner'
      ? API_ENDPOINTS.AUTH.ACCEPT_RULES_OWNER
      : API_ENDPOINTS.AUTH.ACCEPT_RULES_STAFF
    const payload = role === 'owner' ? { owner_id: id } : { staff_id: id }
    const response = await api.post(endpoint, payload)
    return response.data
  },
}

